<script>
import Swal from "sweetalert2";
import _ from "lodash";
import CardTable from "@/components/cardTable/CardTableV2.vue";
import DataTableLotes from "@/components/Datatable/DataTableLotes.vue";

export default {
  components: {
    DataTableLotes,
    CardTable,
    ModalLiquidacionPersonaDetalles: () =>
      import("./ModalLiquidacionPersonaDetalles.vue"),
    NominaAjustePersona: () =>
      import("@/views/Helexium/Nomina/NominaAjustePersona/NominaAjustePersona"),
    NominaConsultaEstados: () =>
      import(
        "@/views/Helexium/Nomina/NominaAjustePersona/NominaConsultaEstados"
      ),
  },
  props: {
    liquidacionId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      EmpresaId: null,
      nominaLiquidacion: undefined,
      listaLiquidacionPersona: [],
      onActiveModalDataLiquidacionPersona: null,
      enPreparacion: false,
      messageEstados: "",
      SelectAll: false,
      enviandoLiquidacion: false,
      dataCards: [
        {
          title: "Empleados",
          value: () => this.LiquidacionesSeleccionadas.length,
          iconName: "users",
          color: "rgba(22, 162, 117, 1)",
          tipo: "squared",
          animated: "bounce",
        },
        {
          title: "Salarios",
          value: () => (this.SeleccionadosTotalSalarios+this.TotalSalarios).toLocaleString("es-CO", { style: "currency", currency: "COP" }),
          iconName: "money-bill-1",
          color: "rgba(71, 136, 255, 1)",
          tipo: "shield",
          animated: "bounce",
        },
        {
          title: "Pagos adicionales",
          value: () => (this.SeleccionadosPagosAdicionalesTotal+this.PagosAdicionalesTotal).toLocaleString("es-CO", { style: "currency", currency: "COP" }),
          iconName: "hand-point-up",
          color: "rgba(71,136,255,1)",
          tipo: "shield",
          animated: "bounce",
        },
        {
          title: "Deducciones",
          value: () => (this.SeleccionadosPagosDeduccionesTotal+this.PagosDeduccionesTotal).toLocaleString("es-CO", { style: "currency", currency: "COP" }),
          iconName: "hand-point-down",
          color: "rgba(223, 18, 46, 1)",
          tipo: "shield",
          animated: "bounce",
        },
        {
          title: "Total a pagar",
          value: () => (this.SeleccionadosTotalAPagarEmpleados+this.TotalAPagarEmpleados).toLocaleString("es-CO", { style: "currency", currency: "COP" }),
          iconName: "hand-holding-dollar",
          color: "rgba(71, 136, 255, 1)",
          tipo: "shield",
          animated: "bounce",
        },
      ],
      columns: [
        //{label: "Liquidar", key: "liquidacionId", sortable: true, width: '80px', columnaBuscar: 'TieneErrores'},
        {label: "Nombre", key: "persona", sortable: true, width: '300px', columnaBuscar: 'Persona.Nombres'},
        {label: "Identificación", key: "Idenficacion", sortable: true, columnaBuscar: 'Persona.NumeroDocumento'},
        { label: "Salario / honorarios", key: "Salario", sortable: true, columnaBuscar: 'NominaLiquidacionPersona.Salario' },
        {label: "Pagos adicionales", key: "totalIngresosAdicionales", sortable: true, columnaBuscar: 'NominaLiquidacionPersona.TotalIngresosAdicionales' },
        {label: "Deducciones", key: "totalDeducciones", sortable: true, columnaBuscar: 'NominaLiquidacionPersona.TotalDeducciones' },
        {label: "Total a pagar", key: "totalPago", sortable: true, columnaBuscar: 'NominaLiquidacionPersona.TotalPago' },
        {label: "Opciones", key: "Opciones", width: '80px'}
      ],
      PersonasLiquidadas: [],
      LiquidacionesSeleccionadas: [],
      CantidadUsuariosDisponiblesLiquidacion: 0,
      CantidadUsuariosDisponiblesLiquidacionTotal: 0,
      CantidadUsuariosLiquidados: 0,
      TotalSalarios: 0,
      PagosAdicionalesTotal: 0,
      PagosDeduccionesTotal: 0,
      TotalAPagarEmpleados: 0,

      SeleccionadosTotalSalarios: 0,
      SeleccionadosPagosAdicionalesTotal: 0,
      SeleccionadosPagosDeduccionesTotal: 0,
      SeleccionadosTotalAPagarEmpleados: 0,
      PrimerLlamado: false,
    };
  },
  watch: {
    empleadosSeleccionados(newValue) {
      const totalFilasSeleccionables = this.empleadosNomina.length;

      this.SelectAll = newValue.length === totalFilasSeleccionables;

      if (newValue.length < totalFilasSeleccionables) {
        this.SelectAll = false;
      }
    },
    SelectAll(newValue) {
      if (newValue) {
        this.seleccionarTodas();
      } else {
        if (this.empleadosSeleccionados.length !== this.empleadosNomina.length)
          return;
        this.deseleccionarTodas();
      }
    },
  },
  async mounted() {
    await this.getData();
    const valor = JSON.parse(localStorage.getItem("setPersonaAct"));
    this.EmpresaId = valor.empresa.id;
    this.initConsultasAutomáticasAportes();
  },
  computed: {
    empleadosNomina() {
      return this.listaLiquidacionPersona.filter(
        (liquidacionPersona) =>
          !liquidacionPersona.liquidado && !liquidacionPersona.error
      );
    },
    empleadosSeleccionados() {
      return this.listaLiquidacionPersona.filter(
        (liquidacionPersona) =>
          liquidacionPersona.estado &&
          !liquidacionPersona.liquidado &&
          !liquidacionPersona.error
      );
    },
    empleadosLiquidados() {
      return this.listaLiquidacionPersona.filter(
        (liquidacionPersona) => liquidacionPersona.liquidado
      );
    },
    empleadosActivos() {
      return this.empleadosSeleccionados.length;
    },
    salarioEmpleadosActivos() {
      let empleados = this.empleadosSeleccionados;
      return empleados
        .reduce((prev, curr) => prev + Number(curr.salario), 0)
        .toLocaleString("es-CO", { style: "currency", currency: "COP" });
    },
    pagosAdicionales() {
      let empleados = this.empleadosSeleccionados;
      return empleados
        .reduce((prev, curr) => prev + Number(curr.totalIngresosAdicionales), 0)
        .toLocaleString("es-CO", { style: "currency", currency: "COP" });
    },
    deducciones() {
      let empleados = this.empleadosSeleccionados;
      return empleados
        .reduce((prev, curr) => prev + Number(curr.totalDeducciones), 0)
        .toLocaleString("es-CO", { style: "currency", currency: "COP" });
    },
    totalAPagar() {
      let empleados = this.empleadosSeleccionados;
      return empleados
        .reduce((prev, curr) => prev + Number(curr.totalPago), 0)
        .toLocaleString("es-CO", { style: "currency", currency: "COP" });
    },
  },
  methods: {
    async recalculaLiquidacion() {
      this.$isLoading(true);
      let fechaInicio = "2025-03-01";
      let fechaFin = "2025-03-31";
      let path = "NominaLiquidacion/CrearNominaLiquidacionAutoEmpresa/3/"+this.EmpresaId +"/"+fechaInicio+"/"+fechaFin+
        "?NuevaLiquidacion=false";
      await this.$store.dispatch("hl_post", {
        path: path,
      });
      this.$isLoading(false);
    },
    seleccionarTodas() {
      this.listaLiquidacionPersona.forEach((liquidacionPersona) => {
        if (!liquidacionPersona.liquidado && !liquidacionPersona.error) {
          liquidacionPersona.estado = true;
        }
      });
    },
    deseleccionarTodas() {
      this.listaLiquidacionPersona.forEach((liquidacionPersona) => {
        if (!liquidacionPersona.liquidado && !liquidacionPersona.error) {
          liquidacionPersona.estado = false;
        }
      });
    },
    async getData() {
      try {
        const liquidacionAll = await this.$store.dispatch('hl_get',{
          path: `NominaLiquidacion/ObtenerInformacionLiquidacion/${this.liquidacionId}`,
        });
        this.nominaLiquidacion = liquidacionAll.data.NominaLiquidacion;
        this.PersonasLiquidadas = liquidacionAll.data.IdsPersonasLiquidadas;

        this.nominaLiquidacion.fechaInicio = this.$moment
          .tz(this.nominaLiquidacion.fechaInicio, "America/Costa_Rica")
          .format("YYYY-MM-DD");
        this.nominaLiquidacion.fechaFin = this.$moment
          .tz(this.nominaLiquidacion.fechaFin, "America/Costa_Rica")
          .format("YYYY-MM-DD");

        this.enPreparacion = !this.nominaLiquidacion.liquidado;

        const TotalesLiquidacion = await this.$store.dispatch('hl_get',{
          path: `NominaLiquidacion/ObtenerTotalesActivaLiquidacion/${this.liquidacionId}`,
        });

        if (TotalesLiquidacion.respuesta) {
          let DatosCard = TotalesLiquidacion.data;
          this.CantidadUsuariosLiquidados = DatosCard.TotalEmpleados;
          this.TotalSalarios = DatosCard.TotalSalario;
          this.PagosAdicionalesTotal = DatosCard.TotalIngresosAdicionales;
          this.PagosDeduccionesTotal = DatosCard.TotalDeducciones;
          this.TotalAPagarEmpleados = DatosCard.TotalAPagar;
        }

      } catch (error) {
        console.error(error);
      }
    },
    mostrarDestallesLiquidacionPersona(liquidacionPersona) {
      this.onActiveModalDataLiquidacionPersona = liquidacionPersona;
      this.$bvModal.show("modalDetallesLiquidacionPersona");
    },
    mostrarPrevalidacionesDeLaPersona(liquidacionPersona) {
      this.onActiveModalDataLiquidacionPersona = liquidacionPersona;
      this.$bvModal.show("modalPrevalidacionesPersona");
    },
    async liquidarNomina() {
      // Actualizacion en el backend
      if (this.LiquidacionesSeleccionadas.length === 0) return;
      this.$isLoading(true);
      this.$store.dispatch('hl_post',{
          path: `NominaLiquidacion/LiquidarPersonasDePreparacion/${this.liquidacionId}`,
          data: this.LiquidacionesSeleccionadas
        })
        .then((response) => {
          if (response.respuesta) {
            Swal.fire("Listo!", "Liquidación procesada correctamente!.", "success")
                .then(() => {
                  this.$router.push({ name: "NominaTransmitir", params: {liquidacionPersonaId: this.liquidacionId}});
                });
          }
          else
          {
            Swal.fire({
              title: "Error",
              text: response.mensaje,
              icon: "error",
              confirmButtonText: "Ok",
            });
          }
        })
        .finally(() => {
          this.$isLoading(false);
        });

      //Actualización en el frontend
      this.nominaLiquidacion.liquidado = true;
      this.empleadosSeleccionados.forEach((nominaPersona) => {
        const index = this.listaLiquidacionPersona.findIndex(
          (liq) => liq.id == nominaPersona.id
        );
        this.listaLiquidacionPersona[index].liquidado = true;
      });
      this.enPreparacion = false;
    },
    mapError(erroresString) {
      return erroresString
        .replace("Errores: ", "")
        .split(", ")
        .map((error) => error.trim());
    },
    initConsultasAutomáticasAportes() {
      const idsLiquidacionPersonasPendientes = this.empleadosLiquidados
        .filter((liq) => liq.estadoAportes === "Pendiente")
        .map((liq) => liq.id);

      this.messageEstados = "Consultando estados en la base de datos";
      if (idsLiquidacionPersonasPendientes.length == 0) {
        this.messageEstados = "";
        this.validarEstadosPorBackEnd();
        return;
      }

      const queryString = idsLiquidacionPersonasPendientes
        .map((id) => `liquidacionPersonaId=${id}`)
        .join("&");
      this.$store.getters
        .fetchGet({
          path: `LiquidadorNomina/GetCuerposConsultaByLiquidacionesPersonasIds?${queryString}`,
        })
        .then((response) => response.json())
        .then((data) => {
          return new Promise((resolve) => {
            resolve(data.map(({ body }) => body));
          });
        })
        .then((bodies) => {
          const groupedData = _.groupBy(bodies, "idTrack");
          const resultado = Object.keys(groupedData).map((idTrack) => ({
            idTrack,
            trabajador: _.flatMap(groupedData[idTrack], "trabajador"),
          }));

          return new Promise((resolve) => {
            resolve(resultado);
          });
        })
        .then(async (bodies) => {
          bodies.forEach(async (body, index) => {
            this.messageEstados = `${
              index + 1
            } Se ha iniciado el proceso de consulta de estados de liquidaciones en Aportes en Línea`;

            const result = await this.consultarPersonaEnAportes(
              JSON.stringify(body)
            );

            this.messageEstados = result.descripcion;
            if (
              this.messageEstados.includes("previamente") ||
              this.messageEstados.includes("validación")
            ) {
              this.messageEstados +=
                "\nEste proceso puede tardar algunas horas. Se le enviara un correo cuando el proceso haya finalizado.";
            }

            const responseSaveData = await this.$store.getters.fetchPut({
              path: `LiquidadorNomina/SaveResultLiquidacionPersonas/${body.idTrack}`,
              data: result,
            });
            const resultSaveData = await responseSaveData.json();

            resultSaveData.forEach((item) => {
              const index = this.listaLiquidacionPersona.findIndex(
                (liq) => liq.id == item.id
              );
              this.listaLiquidacionPersona[index].estadoAportes =
                item.estadoAportes;
            });
          });
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          // setTimeout(() => {
          //   this.messageEstados = ''
          // }, 10000)
        });
    },
    async consultarPersonaEnAportes(body) {
      const token = await this.$store.getters.getTokenAportes();
      const response = await fetch(
        `${this.$store.state.APIAportes}/NominaElectronica/ConsultaEstado`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            token: token,
            "Content-Type": "application/json",
          },
          body: body,
        }
      );
      return await response.json();
    },
    validarEstadosPorBackEnd() {
      const enviadas = this.empleadosLiquidados.filter(
        (liq) => liq.estadoAportes
      );

      if (enviadas.length == 0) {
        this.messageEstados =
          "No se han enviado liquidaciones a Aportes en Línea";
        return;
      }

      const aprobados = enviadas.filter(
        (liq) => liq.estadoAportes === "Aprobado"
      );
      if (aprobados.length == this.empleadosLiquidados.length) {
        this.messageEstados =
          "Todos los documentos de las liquidaciones han sido aprobados";
        return;
      }
    },

    async fetchData({filtro, orden, cantDatos, paginacion}) {
      if (!this.liquidacionId) {
        console.error("EmpresaId no está definido.");
        return {TotalDatos: 0, data: []};
      }
      let params = {
        filtro: filtro,
        orden: orden,
        cantDatos: cantDatos,
        paginacion: paginacion
      };
      let data = [];
      let total = 0;

      await Promise.all([
        this.$store.dispatch('hl_get', {
          path: `NominaLiquidacion/ObtenerCantidadPersonasLotes/${this.liquidacionId}?filtros=${params.filtro}`
        }),
        this.$store.dispatch('hl_post', {
          path: 'NominaLiquidacion/ObtenerLiquidacionLotes/' + this.liquidacionId, data: params
        })
      ]).then(([cantidadDatos, Datos]) => {
        if (!this.PrimerLlamado){
          this.PersonasLiquidadas.forEach(persona => {
            if (!this.$refs.tablaLotes.ArraySeleccionados.includes(persona)) {
              this.$refs.tablaLotes.ArraySeleccionados.push(persona);
            }
          });
          this.PersonasLiquidadas.forEach(persona => {
            if (!this.LiquidacionesSeleccionadas.includes(persona)) {
              this.LiquidacionesSeleccionadas.push(persona);
            }
          });
          this.PrimerLlamado = true;
        }


        if (cantidadDatos.respuesta) {
          this.CantidadUsuariosDisponiblesLiquidacion = cantidadDatos.data.TotalDisponibles;
          this.CantidadUsuariosDisponiblesLiquidacionTotal = cantidadDatos.data.TotalDisponiblesSeleccion;
          total = cantidadDatos.data.TotalTablas;
        }
        if (Datos.respuesta) {
          data = Datos.data;
        }
      });
      console.log("Datos obtenidos:", data);
      console.log("Datos totales obtenidos:", total);

      return {total, data};
    },
    async SeleccionarTodos(search) {
      console.log("SeleccionarTodos", search);
      let todos = await this.$store.dispatch('hl_get',
          {path: `NominaLiquidacion/ObtenerTodosUsuarios/${this.liquidacionId}?filtros=${search}`});
      console.log("Todos", todos);
      if (todos.respuesta) return todos.data;
      return [];
    },
    handleUpdate(data) {
      this.listaLiquidacionPersona = data;
    },
    miComprobacionSeleccion() {
      return this.LiquidacionesSeleccionadas.length >= this.CantidadUsuariosDisponiblesLiquidacionTotal;
    },
    ClickUsuario(row, event) {
      const seleccionado = event.target.checked;
      this.$refs.tablaLotes?.SeleccionDatosMultiple(row);

      // this.LiquidacionesSeleccionadas.map((item, index) => {
        
      // });

      if (seleccionado) {
        this.SeleccionadosTotalSalarios += row.salario;
        this.SeleccionadosPagosAdicionalesTotal += row.totalIngresosAdicionales;
        this.SeleccionadosPagosDeduccionesTotal += row.totalDeducciones;
        this.SeleccionadosTotalAPagarEmpleados += row.totalPago;
      } else {
        this.SeleccionadosTotalSalarios -= row.salario;
        this.SeleccionadosPagosAdicionalesTotal -= row.totalIngresosAdicionales;
        this.SeleccionadosPagosDeduccionesTotal -= row.totalDeducciones;
        this.SeleccionadosTotalAPagarEmpleados -= row.totalPago;
      }
    },
    async ActualizarTotales({ seleccion, search }){
      let PreciosTotales = await this.$store.dispatch('hl_get',
          {path: `NominaLiquidacion/ObtenerTotalesNomina/${this.liquidacionId}?filtros=${search}`});

      if (seleccion) {
        this.SeleccionadosTotalSalarios = PreciosTotales.data.TotalSalario;
        this.SeleccionadosPagosAdicionalesTotal = PreciosTotales.data.TotalIngresosAdicionales;
        this.SeleccionadosPagosDeduccionesTotal = PreciosTotales.data.TotalDeducciones;
        this.SeleccionadosTotalAPagarEmpleados = PreciosTotales.data.TotalPago;
      }
      else {
        this.SeleccionadosTotalSalarios -= PreciosTotales.data.TotalSalario;
        this.SeleccionadosPagosAdicionalesTotal -= PreciosTotales.data.TotalIngresosAdicionales;
        this.SeleccionadosPagosDeduccionesTotal -= PreciosTotales.data.TotalDeducciones;
        this.SeleccionadosTotalAPagarEmpleados -= PreciosTotales.data.TotalPago;
      }
    }
  },
  filters: {
    nombreCompleto(obj) {
      const persona = obj.persona;
      return (
        persona.nombres +
        " " +
        (persona.segundoNombre != null ? persona.segundoNombre : "") +
        " " +
        persona.apellidos +
        " " +
        (persona.segundoApellido != null ? persona.segundoApellido : "")
      );
    },
    formatoMoneda(valor) {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
      }).format(valor);
    },
  },
};
</script>

<template>
  <div>
    <!-- Este bloque se puede mejorar -->
    <card>
      <h4 class="px-4 py-4"><b>información de la nómina</b></h4>
      <template v-slot:headerTitle></template>
      <div class="row px-5 mb-4">
        <div class="col-md-6">
          <label for=" " class="form-label"> Período de Liquidación </label>
          <div>
            <!-- :readonly="item.tipoLiquidacion == 1 || item.tipoLiquidacion == 2" -->
            <label for=" " class="form-label">Fecha inicio</label>
            <input
              readonly
              required
              :value="nominaLiquidacion?.fechaInicio"
              placeholder=""
              type="date"
              class="form-control"
              id=" "
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mt-4">
            <label for=" " class="form-label">Fecha fin</label>
            <!-- :readonly="nominaLiquidacion.tipoLiquidacion == 1 || nominaLiquidacion.tipoLiquidacion == 2" -->
            <input
              readonly
              :value="nominaLiquidacion?.fechaFin"
              required
              placeholder=""
              type="date"
              class="form-control"
              id=" "
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mt-4">
            <label for=" " class="form-label">Tipo de Liquidación</label>
            <input
              disabled
              :value="
                nominaLiquidacion?.tipoLiquidacion == 1
                  ? 'Primer semestre'
                  : nominaLiquidacion?.tipoLiquidacion == 2
                  ? 'Último semestre / Navideña'
                  : 'Nómina'
              "
              required
              placeholder=""
              type="text"
              class="form-control"
              id=" "
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mt-4">
            <label for=" " class="form-label">Estado</label>
            <input
              disabled
              :value="nominaLiquidacion?.estado == 1 ? 'Liquidado' : ''"
              required
              placeholder=""
              type="text"
              class="form-control"
              id=" "
            />
          </div>
        </div>
      </div>
      <div class="px-5">
        <div class="row">
          <div class="col-12">
            <CardTable :data="dataCards" />
          </div>
          <!-- <div class="col-12 col-md">
                    <BtnAddCardTable text="Abrir Ticket" url="AgregarTickets" />
                  </div> -->
        </div>
      </div>
      <div class="p-4">
        <div class="border border-1 border-white p-2 rounded rounded-2">
          <div class="mb-4">
            <!-- <vs-button @click.prevent="recalculaLiquida()" gradient>Recalcular liquidación</vs-button> -->
            <div class="d-flex" style="gap: 0.5rem">
              <vs-button @click="recalculaLiquidacion()">Recalcular Nomina</vs-button>
              <vs-button @click="liquidarNomina" gradient danger :disabled="!LiquidacionesSeleccionadas.length">
                Preparar nomina
              </vs-button>
            </div>
          </div>
          <!--<table
            id="datatable_empleados" style="display: none"
            class="table table-bordered table-responsive-md table-striped text-center"
          >
            <thead>
              <tr>
                <th>Liquidar</th>
                <th>Nombre</th>
                <th>Identificación</th>
                <th>Salario</th>
                <th>Pagos adicionales</th>
                <th>Deducciones</th>
                <th>Total a pagar</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="liquidacionPersona in listaLiquidacionPersona"
                :key="liquidacionPersona.dataId"
              >
                <td>
                  {{liquidacionPersona.estado}}
                  <span @click="mostrarPrevalidacionesDeLaPersona(liquidacionPersona)"
                    v-if="liquidacionPersona.error"
                    class="pointer" >
                    <i class="fas fa-solid fa-exclamation-triangle text-danger mr-2"></i>
                  </span>
                  <HelexCheckBtn v-else-if="!liquidacionPersona.liquidado"
                    v-model="liquidacionPersona.estado">
                  </HelexCheckBtn>
                  <span v-else>Liquidado</span>
                </td>
                <td>{{ liquidacionPersona | nombreCompleto }}</td>
                <td>{{ liquidacionPersona.persona.numeroDocumento }}</td>
                <td>
                  {{ liquidacionPersona.persona.salario | formatoMoneda }}
                </td>
                <td>
                  {{
                    liquidacionPersona.totalIngresosAdicionales | formatoMoneda
                  }}
                </td>
                <td>
                  {{ liquidacionPersona.totalDeducciones | formatoMoneda }}
                </td>
                <td>{{ liquidacionPersona.totalPago | formatoMoneda }}</td>
                <td>
                  <div
                    class="text-center"
                    style="gap: 0.5rem"
                    v-if="
                      liquidacionPersona.liquidado ||
                      (liquidacionPersona.estado && !liquidacionPersona.error)
                    "
                  >
                    <span
                      @click="
                        mostrarDestallesLiquidacionPersona(liquidacionPersona)
                      "
                      class="pointer"
                    >
                      <i class="fas fa-solid fa-eye text-success mx-1"></i>
                    </span>
                    <router-link
                      :to="{
                        path: `/helex/liquidacioneditardetalle/${liquidacionId}/${liquidacionPersona.persona.id}`,
                      }"
                      class="pointer"
                    >
                      <span>
                        <i class="fas fa-solid fa-file text-success mx-1"></i>
                      </span>
                    </router-link>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>-->
          Seleccionados [{{ LiquidacionesSeleccionadas.length }}] Disponibles [{{CantidadUsuariosDisponiblesLiquidacion}}]
          SeleccionTotalDisponibles [{{CantidadUsuariosDisponiblesLiquidacionTotal}}]

          <DataTableLotes ref="tablaLotes" :fetch-data="fetchData" :columns="columns" :busqueda-boton=true
                          @update:data="handleUpdate" :seleccion-multiple=true LabelBusquedaMultiple="Liquidar"
                          :array-seleccionados="LiquidacionesSeleccionadas" orden-columna-seleccion-multiple="TieneErrores"
                          :fetchDataAllSelect="SeleccionarTodos" key-seleccion="id"
                          @KeySelection="LiquidacionesSeleccionadas = $event"
                          :comprobar-seleccion-total="miComprobacionSeleccion" @SeleccionDatos="ActualizarTotales"
                          :cantidad-disponibles-seleccion-multiple="CantidadUsuariosDisponiblesLiquidacion">
            <!--<template v-slot:checkbox="{ row }">
              <td>
              <span @click="mostrarPrevalidacionesDeLaPersona(row)"
                    v-if="row.error"
                    class="pointer">
                    <i class="fas fa-solid fa-exclamation-triangle text-danger mr-2"></i>
                  </span>
                <HelexCheckBtn v-else-if="!row.liquidado"
                               v-model="row.estado" @change="$refs.tablaLotes.DevolverDatosActualizados();">
                </HelexCheckBtn>
                <span v-else>Liquidado</span>
              </td>
            </template>-->
            <template v-slot:checkbox="{ row }">
              <td>
                <span @click="mostrarPrevalidacionesDeLaPersona(row)" v-if="row.error" class="pointer">
                  <i class="fas fa-solid fa-exclamation-triangle text-danger mr-2"></i>
                </span>
                <input v-else-if="!row.liquidado" type="checkbox"
                    :checked="$refs.tablaLotes?.SeleccionadosDatosMultiples(row)"
                    @change="ClickUsuario(row, $event)"
                />
                <span v-else>Liquidado</span>
              </td>
            </template>
            <template v-slot:persona="{ row }">
              {{ row | nombreCompleto }}
            </template>
            <template v-slot:Idenficacion="{ row }">
              {{ row.persona.numeroDocumento }}
            </template>
            <template v-slot:Salario="{ row }">
              {{ row.salario | formatoMoneda }}
            </template>
            <template v-slot:totalIngresosAdicionales="{ row }">
              {{ row.totalIngresosAdicionales | formatoMoneda }}
            </template>
            <template v-slot:totalDeducciones="{ row }">
              {{ row.totalDeducciones | formatoMoneda }}
            </template>
            <template v-slot:totalPago="{ row }">
              {{ row.totalPago | formatoMoneda }}
            </template>
            <template v-slot:Opciones="{ row }">
              <div class="text-center" style="gap: 0.5rem" v-if="LiquidacionesSeleccionadas.filter(x => x === row.id).length === 1">
                <span @click="mostrarDestallesLiquidacionPersona(row)" class="pointer">
                  <i class="fas fa-solid fa-eye text-success mx-1"></i>
                </span>
                <router-link :to="{path: `/helex/liquidacioneditardetalle/${liquidacionId}/${row.persona.id}`}"
                             class="pointer">
                      <span><i class="fas fa-solid fa-file text-success mx-1"></i></span>
                </router-link>
              </div>
            </template>
          </DataTableLotes>

        </div>
      </div>
    </card>
    <b-modal
      title="Prevalidaciones"
      id="modalPrevalidacionesPersona"
      size="xl"
      hide-footer
    >
      <template #default="{ close }">
        <div v-if="onActiveModalDataLiquidacionPersona" class="mb-3">
          <div>
            <h3>{{ onActiveModalDataLiquidacionPersona | nombreCompleto }}</h3>
            <p>
              {{ onActiveModalDataLiquidacionPersona.persona.numeroDocumento }}
            </p>
          </div>
          <div
            class="border-1 border border-white p-3"
            v-if="onActiveModalDataLiquidacionPersona.error"
          >
            <p>Datos faltantes de la persona</p>
            <ul class="p-0">
              <li
                v-for="(error, index) in mapError(
                  onActiveModalDataLiquidacionPersona.error
                )"
                :key="index"
              >
                {{ error }}
              </li>
            </ul>
          </div>
          <div v-else>
            <p>Todo en orden</p>
          </div>
        </div>
        <div class="w-100 d-flex flex-row-reverse">
          <vs-button gradient success @click="close"> Cerrar </vs-button>
          <router-link
            target="_blank"
            :to="{
              path: `/helex/Persona_editar/${onActiveModalDataLiquidacionPersona.persona.id}`,
            }"
          >
            <vs-button gradient>Ir al perfil</vs-button>
          </router-link>
        </div>
      </template>
    </b-modal>

    <b-modal title="Liquidación" id="modalDetallesLiquidacionPersona" size="xl" hide-footer>
      <template #default="{ close }">
        <ModalLiquidacionPersonaDetalles v-if="onActiveModalDataLiquidacionPersona"
          :nominaLiquidacionPersonaDetalle="onActiveModalDataLiquidacionPersona.nominaLiquidacionPersonaDetalle" >
        </ModalLiquidacionPersonaDetalles>
        <div class="w-100 text-right">
          <button class="mx-1 btn px-4 py-2 btn-success" @click="close">
            Cerrar
          </button>
        </div>
      </template>
    </b-modal>

    <b-modal
      title="Nomina de ajuste"
      id="modalNominaDeAjuste"
      size="xl"
      hide-footer
    >
      <NominaAjustePersona
        v-if="onActiveModalDataLiquidacionPersona"
        :liquidacionId="liquidacionId"
        :liquidacionPersonaId="onActiveModalDataLiquidacionPersona.id"
      ></NominaAjustePersona>
    </b-modal>

    <b-modal
      title="Consultar estado"
      id="modalConsultaDeEstado"
      size="md"
      hide-footer
    >
      <NominaConsultaEstados
        v-if="onActiveModalDataLiquidacionPersona"
        :liquidacionPersonaId="onActiveModalDataLiquidacionPersona.id"
      />
    </b-modal>
  </div>
</template>

<style scoped>
.check-button {
  border: 1px solid #cacaca;
}
</style>
